class Movie {
  constructor({
    MovieID = "",
    MovieName = "",
    Actors = "",
    Director = "",
    CensorRating = "",
    Duration = "",
    MovieImageSmall = "",
    MovieImageBig = "",
    MovieTrailer = "",
    Description = "",
    ShowTimes = [],
    genre = ["Genres"],
  }) {
    this.MovieID = MovieID;
    this.MovieName = MovieName;
    this.Actors = Actors;
    this.Director = Director;
    this.CensorRating = CensorRating;
    this.Duration = Duration;
    this.MovieImageSmall = MovieImageSmall;
    this.MovieImageBig = MovieImageBig;
    this.MovieTrailer = MovieTrailer;
    this.Description = Description;
    this.ShowTimes = ShowTimes;
    this.genre = [CensorRating];
    this.experience = ExperienceCheck(MovieName);
  }
}

/**@param {string} movieName */
const ExperienceCheck = (movieName) => {
  if (movieName.includes("2D")) {
    return "2D";
  }
  if (movieName.includes("3D")) {
    return "3D";
  }
  return "2D";
};

export default Movie;
